import { render } from "./StoryMetadataIcon.vue.js?vue&type=template&id=4064cf36!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryMetadataIcon.vue?vue&type=template&id=4064cf36"
import script from "./StoryMetadataIcon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryMetadataIcon.vue?vue&type=script&lang=js"
export * from "./StoryMetadataIcon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryMetadataIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/StoryMetadataIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4064cf36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4064cf36', __exports__)) {
    api.reload('4064cf36', __exports__)
  }
  
  module.hot.accept("./StoryMetadataIcon.vue.js?vue&type=template&id=4064cf36!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryMetadataIcon.vue?vue&type=template&id=4064cf36", () => {
    api.rerender('4064cf36', render)
  })

}


export default __exports__